import React from "react";
import { getUrl } from "../../helpers/Pipes";
import parse from "html-react-parser";
import { SectionText } from "../../components/SectionText/SectionText";

export const LinkNormativa = () => {
  return (
    <SectionText
      hideTitle="yes"
      textLabel={parse(
        `Prendi visione dell'informativa resa da Compass ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 e della normativa nazionale vigente in materia di protezione dei dati personali <a target='_blank' href='${getUrl(
          "normativaPrivacy"
        )}'>qui scaricabile</a>.`
      )}
      customClasses="mBottom4x"
    />
  );
};
